/* eslint-disable react-hooks/exhaustive-deps */
import TabNav from "components/TabNav";
import { useCallback, useEffect, useState } from "react";

import ConfirmationModal from "components/ConfirmationModal";
import { useAuth } from "contexts/AuthContext";
import { useToast } from "contexts/ToastContext";
import { useHasRole } from "contexts/AuthContext";
import AssignedProsecutorHistory from "pages/complaintRequest/fragments/AssignedProsecutorHistory";
import RejectAppealModal from "pages/complaintRequest/fragments/RejectAppealModal";
import { useParams } from "react-router-dom";
import { fetchAdminUnitDetail } from "services/advocateComplaintService";
import {
  editAppeal,
  editComplaint,
  fetchAppealAssignmentHistory,
  fetchAppealByComplaintId,
  fetchAppealCouncilLitigationByAppealSummonId,
  fetchAppealLitigationByAppealSummonId,
  fetchComplaintById,
  fetchCouncilLitigationBySummonId,
  fetchInvestigationByComplaintId,
  fetchLitigationBySummonId,
  fetchSummonByAppealId,
  fetchSummonByInvestigationId,
} from "services/prosecutorDecipilineService";
import {
  AdminUnit,
  Appeal,
  Complaints,
  CouncilLitigation,
  Investigation,
  Litigation,
  Summon,
} from "types";
import {
  APPEAL_STATUS,
  APPEAL_TYPE,
  COMPLIANT_STATUS,
  HIERARCHY_LEVELS,
  INVESTIGATION_STATUS,
} from "utils/constantValues";
import { ROLES } from "utils/roles";
import { useTranslation } from "contexts/i18nContext";
import ChargeDocumentCardAdvocate from "../complaintRequest/fragments/ChargeDocumentCardAdvocate";
import ComplaintDetailInfoCard from "../complaintRequest/fragments/ComplaintDetailInfoCard";
import DecisionCard from "../complaintRequest/fragments/DecisionCard";
import ListEvidenceCard from "../complaintRequest/fragments/ListEvidenceCard";
import ListReporterCard from "../complaintRequest/fragments/ListReporterCard";
import ListVictimCard from "../complaintRequest/fragments/ListVictimCard";
import ListWitnessCard from "../complaintRequest/fragments/ListWitnessCard";
import AddAppealCouncilLitigationDecisionModal from "./fragments/AddAppealCouncilLitigationDecisionModal";
import AddAppealDailyHearingModal from "./fragments/AddAppealDailyHearingModal";
import AddAppealLitigationDecisionModal from "./fragments/AddAppealLitigationDecisionModal";
import AddAppealSummonModal from "./fragments/AddAppealSummonModal";
import AddAppealToCourtModal from "./fragments/AddAppealToCourtModal";
import AddCouncilOfficeVerdictInitialDay from "./fragments/AddCouncilOfficeVerdictInitialDay";
import AppealCard from "./fragments/AppealCard";
import AppealCouncilLitigationCard from "./fragments/AppealCouncilLitigationCard";
import AppealLitigationCard from "./fragments/AppealLitigationCard";
import AppealSummonCard from "./fragments/AppealSummonCard";
import InitialDecisionCard from "./fragments/InitialDecisionCard";
import SummonConfirmationStatus from "./fragments/SummonConfirmationStatus";

export default function SingleAppealForZonal() {
  const { t } = useTranslation();
  const { uu_id } = useParams();
  const { user } = useAuth();
  const { showToast } = useToast();

  const canCreateAppealSummon = useHasRole([
    ROLES.REGIONAL_COUNCIL_OFFICE_WRITER,
    ROLES.ZONAL_COUNCIL_OFFICE_HEAD,
  ]);

  // const canSendInvestigationToCouncil = useHasRole([
  //   ROLES.INSPECTION_DIRECTOR,
  //   ROLES.INSPECTION_COORDINATOR,
  // ]);
  const canCreateInspectionDailyHearing = useHasRole([
    ROLES.INSPECTION_PROSECUTOR,
  ]);
  const canCreateCouncilDailyHearing = useHasRole([
    ROLES.REGIONAL_COUNCIL_OFFICE_WRITER,
  ]);
  // const canTerminateInspectionLitigation = useHasRole([
  //   ROLES.INSPECTION_PROSECUTOR,
  // ]);
  // const canTerminateCouncilLitigation = useHasRole([
  //   ROLES.REGIONAL_COUNCIL_OFFICE_HEAD,
  //   ROLES.ZONAL_COUNCIL_OFFICE_HEAD,
  // ]);
  const isRegionalCouncilOfficeHead = useHasRole([
    ROLES.REGIONAL_COUNCIL_OFFICE_HEAD,
  ]);
  const canCreateLitigationDecision = useHasRole([ROLES.INSPECTION_PROSECUTOR]);
  const canCreateCouncilLitigationDecision = useHasRole([
    ROLES.REGIONAL_COUNCIL_OFFICE_WRITER,
  ]);
  const canViewCompliantDetail = useHasRole([
    ROLES.INSPECTION_PROSECUTOR,
    ROLES.INSPECTION_COORDINATOR,
    ROLES.INSPECTION_DIRECTOR,
  ]);
  const canViewSummonConfirmation = useHasRole([
    ROLES.REGIONAL_COUNCIL_OFFICE_HEAD,
    ROLES.ZONAL_COUNCIL_OFFICE_HEAD,
    ROLES.REGIONAL_COUNCIL_OFFICE_WRITER,
    ROLES.ZONAL_COUNCIL_OFFICE_WRITER,
  ]);
  const canViewAssignedHistory = useHasRole([
    ROLES.INSPECTION_COORDINATOR,
    ROLES.INSPECTION_DIRECTOR,
  ]);
  const canSendAppealToRegistrar = useHasRole([ROLES.INSPECTION_PROSECUTOR]);
  const canSendAppealToCouncil = useHasRole([ROLES.INSPECTION_PROSECUTOR]);
  const canViewChargeDoc = useHasRole([
    ROLES.INSPECTION_COORDINATOR,
    ROLES.INSPECTION_DIRECTOR,
    ROLES.REGIONAL_COUNCIL_OFFICE_HEAD,
    ROLES.ZONAL_COUNCIL_OFFICE_HEAD,
    ROLES.REGIONAL_COUNCIL_OFFICE_WRITER,
    ROLES.ZONAL_COUNCIL_OFFICE_WRITER,
    ROLES.INSPECTION_PROSECUTOR,
    ROLES.INSPECTION_REGISTRAR,
  ]);
  const canAppealToCourt = useHasRole([ROLES.INSPECTION_PROSECUTOR]);

  const [complaintData, setComplaintData] = useState<
    Complaints | Complaints[]
  >();
  const [investigationData, setInvestigationData] = useState<Investigation>();
  const [allInvestigationData, setAllInvestigationData] =
    useState<Investigation[]>();
  const [summonData, setSummonData] = useState<Summon>();
  const [councilLitigationData, setCouncilLitigationData] =
    useState<CouncilLitigation[]>();

  // const [appealData, setAppealData] = useState<Appeal[]>();
  const [councilAppealData, setCouncilAppealData] = useState<Appeal[]>();
  const [courtAppealData, setCourtAppealData] = useState<Appeal[]>();
  const [
    courtAppealDataForGeneralCouncil,
    setCourtAppealDataForGeneralCouncil,
  ] = useState<Appeal[]>();
  const [courtAppealDataForCourt, setCourtAppealDataForCourt] =
    useState<Appeal[]>();
  const [appealSummonData, setAppealSummonData] = useState<Summon>();
  const [
    courtAppealSummonDataForGeneralCouncil,
    setCourtAppealSummonDataForGeneralCouncil,
  ] = useState<Summon>();
  const [courtAppealSummonDataForCourt, setCourtAppealSummonDataForCourt] =
    useState<Summon>();
  const [appealLitigationData, setAppealLitigationData] =
    useState<Litigation[]>();
  const [
    courtAppealLitigationDataForGeneralCouncil,
    setCourtAppealLitigationDataForGeneralCouncil,
  ] = useState<Litigation[]>();
  const [
    courtAppealLitigationDataForCourt,
    setCourtAppealLitigationDataForCourt,
  ] = useState<Litigation[]>();
  const [appealCouncilLitigationData, setAppealCouncilLitigationData] =
    useState<CouncilLitigation[]>();
  const [
    courtAppealCouncilLitigationData,
    setCourtAppealCouncilLitigationData,
  ] = useState<CouncilLitigation[]>();
  const [adminUnitData, setAdminUnitData] = useState<AdminUnit>();
  const [assignmentHistoryData, setAssignmentHistoryData] = useState<any>();

  // const [isSummonOpen, setIsSummonOpen] = useState(false);
  const [isAppealSummonOpen, setIsAppealSummonOpen] = useState(false);
  const [isDailyHearingOpen, setIsDailyHearingOpen] = useState(false);
  const [isRejectAppealOpen, setIsRejectAppealOpen] = useState(false);
  // const [isAppealFormOpen, setIsAppealFormOpen] = useState(false);
  // const [isTerminateOpen, setIsTerminateOpen] = useState(false);
  const [isAppealGeneralCouncilOpen, setIsAppealGeneralCouncilOpen] =
    useState(false);
  const [isAppealCourtOpen, setIsAppealCourtOpen] = useState(false);
  const [isLitigationDecisionOpen, setIsLitigationDecisionOpen] =
    useState(false);
  const [isCouncilLitigationDecisionOpen, setIsCouncilLitigationDecisionOpen] =
    useState(false);
  const [isSendToCouncilModal, setIsSendToCouncilModal] =
    useState<boolean>(false);
  const [isSendToRegistrarModal, setIsSendToRegistrarModal] =
    useState<boolean>(false);
  const [isSubmitLoading, setIsSubmitLoading] = useState(false);
  const [isInitialLoading, setIsInitialLoading] = useState(true);
  // const [loading, setLoading] = useState(false);
  // const [error, setError] = useState("");
  const [isAppealRejectOpen, setIsAppealRejectOpen] = useState(false);
  const [isInitialHearingDecisionOpen, setIsInitialHearingDecisionOpen] =
    useState(false);

  const tabs = [
    t("detailInformation"),
    (councilAppealData?.length ?? 0) > 0 && t("councilAppeal"),

    ((appealCouncilLitigationData?.length ?? 0) > 0 ||
      (appealLitigationData?.length ?? 0) > 0) &&
      t("councilAppealLitigation"),

    (courtAppealDataForGeneralCouncil?.length ?? 0) > 0 &&
      t("appealToGeneralCouncil"),

    (courtAppealDataForGeneralCouncil?.length ?? 0) > 0 &&
      courtAppealDataForGeneralCouncil![0]?.assigned_prosecutor &&
      // courtAppealDataForGeneralCouncil![0]?.appeal_status ===
      //   APPEAL_STATUS.FORWARDED_TO_REGISTRAR &&
      // courtAppealDataForGeneralCouncil![0]?.registration_number &&
      t("generalCouncilAppealLitigation"),

    (courtAppealDataForCourt?.length ?? 0) > 0 && t("courtAppeal"),

    (courtAppealDataForCourt?.length ?? 0) > 0 &&
      courtAppealDataForCourt![0]?.appeal_status ===
        APPEAL_STATUS.FORWARDED_TO_REGISTRAR &&
      courtAppealDataForCourt![0]?.registration_number &&
      t("courtAppealLitigation"),
  ].filter((tab): tab is string => Boolean(tab));

  const [activeTab, setActiveTab] = useState<string>(tabs[0]);

  const isNotFoundError = (error: any) => {
    const status =
      error?.response?.status ?? error?.status ?? error?.request?.status;
    return status === 404;
  };

  useEffect(() => {
    if (tabs.length > 0 && !tabs.includes(activeTab)) {
      setActiveTab(tabs[0]);
    }
  }, [tabs, activeTab]);

  const loadInitialPageData = async () => {
    if (!uu_id) {
      setIsInitialLoading(false);
      return;
    }

    setIsInitialLoading(true);

    try {
      if (user?.admin_unit && user?.access) {
        try {
          const adminUnitDetail = await fetchAdminUnitDetail(
            user.admin_unit,
            user.access,
          );
          setAdminUnitData(adminUnitDetail);
        } catch (err) {
          if (!isNotFoundError(err)) {
            throw err;
          }
          setAdminUnitData(undefined);
        }
      } else {
        setAdminUnitData(undefined);
      }

      const complaintRes = await fetchComplaintById(uu_id);
      const latestComplaint = Array.isArray(complaintRes)
        ? complaintRes?.slice()?.reverse()[0]
        : complaintRes;
      setComplaintData(latestComplaint);

      let latestInvestigation: Investigation | undefined;
      try {
        const investigationRes = await fetchInvestigationByComplaintId(uu_id);
        if (investigationRes) {
          const sortedInvestigations = investigationRes?.slice()?.reverse();
          latestInvestigation = Array.isArray(investigationRes)
            ? sortedInvestigations[0]
            : investigationRes;
          setAllInvestigationData(sortedInvestigations);
          setInvestigationData(latestInvestigation);
        } else {
          setAllInvestigationData(undefined);
          setInvestigationData(undefined);
        }
      } catch (err) {
        if (isNotFoundError(err)) {
          setAllInvestigationData(undefined);
          setInvestigationData(undefined);
        } else {
          throw err;
        }
      }

      let latestSummon: Summon | undefined;
      if (latestInvestigation?.uu_id) {
        try {
          const summonRes = await fetchSummonByInvestigationId(
            latestInvestigation.uu_id,
          );
          latestSummon = Array.isArray(summonRes)
            ? summonRes?.slice()?.reverse()[0]
            : summonRes;
          setSummonData(latestSummon);
        } catch (err) {
          if (isNotFoundError(err)) {
            setSummonData(undefined);
          } else {
            throw err;
          }
        }
      } else {
        setSummonData(undefined);
      }

      if (latestSummon && latestComplaint) {
        try {
          await fetchLitigationBySummonId(uu_id || "");
        } catch (err) {
          if (!isNotFoundError(err)) {
            throw err;
          }
        }
      }

      if (latestSummon) {
        try {
          const councilLitigationRes = await fetchCouncilLitigationBySummonId(
            latestSummon?.id || "",
          );
          setCouncilLitigationData(
            councilLitigationRes
              ? councilLitigationRes?.slice()?.reverse()
              : [],
          );
        } catch (err) {
          if (isNotFoundError(err)) {
            setCouncilLitigationData([]);
          } else {
            throw err;
          }
        }
      } else {
        setCouncilLitigationData(undefined);
      }

      const appealRes = await fetchAppealByComplaintId(uu_id).catch((err) => {
        if (isNotFoundError(err)) return [] as Appeal[];
        throw err;
      });

      const sortedAppeals = appealRes
        ?.slice()
        ?.sort(
          (a, b) =>
            new Date(b?.createdAt ?? "").getTime() -
            new Date(a?.createdAt ?? "").getTime(),
        );

      const councilAppeals = sortedAppeals?.filter(
        (obj) =>
          obj.appeal_type ===
          APPEAL_TYPE.INSPECTION_PROSECUTOR_TO_COUNCIL_OFFICE,
      );
      const courtAppeals = sortedAppeals?.filter(
        (obj) => obj.appeal_type === APPEAL_TYPE.ACCUSED_PROSECUTOR_TO_COURT,
      );

      const courtAppealsToCourt = courtAppeals?.filter(
        (d) => d?.is_appeal_to_court,
      );
      const courtAppealsToGeneralCouncil = courtAppeals?.filter(
        (d) => d?.is_appeal_to_general_council,
      );

      setCouncilAppealData(councilAppeals || []);
      setCourtAppealData(courtAppealsToCourt || []);
      setCourtAppealDataForGeneralCouncil(courtAppealsToGeneralCouncil || []);
      setCourtAppealDataForCourt(courtAppealsToCourt || []);

      let latestAppealSummon: Summon | undefined;
      if (councilAppeals && councilAppeals.length > 0) {
        try {
          const appealSummonRes = await fetchSummonByAppealId(
            councilAppeals[0]?.id || "",
          );
          latestAppealSummon = Array.isArray(appealSummonRes)
            ? appealSummonRes?.slice()?.reverse()[0]
            : appealSummonRes;
          setAppealSummonData(latestAppealSummon);
        } catch (err) {
          if (isNotFoundError(err)) {
            setAppealSummonData(undefined);
          } else {
            throw err;
          }
        }
      } else {
        setAppealSummonData(undefined);
      }

      let latestGeneralCouncilSummon: Summon | undefined;
      if (
        courtAppealsToGeneralCouncil &&
        courtAppealsToGeneralCouncil.length > 0
      ) {
        try {
          const generalCouncilSummonRes = await fetchSummonByAppealId(
            courtAppealsToGeneralCouncil[0]?.id || "",
          );
          latestGeneralCouncilSummon = Array.isArray(generalCouncilSummonRes)
            ? generalCouncilSummonRes?.slice()?.reverse()[0]
            : generalCouncilSummonRes;
          setCourtAppealSummonDataForGeneralCouncil(latestGeneralCouncilSummon);
        } catch (err) {
          if (isNotFoundError(err)) {
            setCourtAppealSummonDataForGeneralCouncil(undefined);
          } else {
            throw err;
          }
        }
      } else {
        setCourtAppealSummonDataForGeneralCouncil(undefined);
      }

      let latestCourtAppealSummon: Summon | undefined;
      if (courtAppealsToCourt && courtAppealsToCourt.length > 0) {
        try {
          const courtAppealSummonRes = await fetchSummonByAppealId(
            courtAppealsToCourt[0]?.id || "",
          );
          latestCourtAppealSummon = Array.isArray(courtAppealSummonRes)
            ? courtAppealSummonRes?.slice()?.reverse()[0]
            : courtAppealSummonRes;
          setCourtAppealSummonDataForCourt(latestCourtAppealSummon);
        } catch (err) {
          if (isNotFoundError(err)) {
            setCourtAppealSummonDataForCourt(undefined);
          } else {
            throw err;
          }
        }
      } else {
        setCourtAppealSummonDataForCourt(undefined);
      }

      const appealLitigationRes = await fetchAppealLitigationByAppealSummonId(
        uu_id || "",
      ).catch((err) => {
        if (isNotFoundError(err)) return [] as Litigation[];
        throw err;
      });

      if (latestAppealSummon) {
        setAppealLitigationData(
          appealLitigationRes
            ?.slice()
            ?.reverse()
            ?.filter(
              (obj) =>
                obj.summon?.toString() === latestAppealSummon?.id?.toString(),
            ),
        );
      } else {
        setAppealLitigationData([]);
      }

      setCourtAppealLitigationDataForGeneralCouncil(
        appealLitigationRes
          ?.slice()
          ?.sort(
            (a, b) =>
              new Date(b?.createdAt ?? "").getTime() -
              new Date(a?.createdAt ?? "").getTime(),
          )
          ?.filter((obj) =>
            courtAppealsToGeneralCouncil &&
            courtAppealsToGeneralCouncil?.length > 0
              ? obj.appeal_request?.toString() ===
                courtAppealsToGeneralCouncil[0]?.id?.toString()
              : false,
          ),
      );

      setCourtAppealLitigationDataForCourt(
        appealLitigationRes
          ?.slice()
          ?.sort(
            (a, b) =>
              new Date(b?.createdAt ?? "").getTime() -
              new Date(a?.createdAt ?? "").getTime(),
          )
          ?.filter((obj) =>
            courtAppealsToCourt && courtAppealsToCourt?.length > 0
              ? obj.appeal_request?.toString() ===
                courtAppealsToCourt[0]?.id?.toString()
              : false,
          ),
      );

      if (latestAppealSummon) {
        const appealCouncilLitigationRes =
          await fetchAppealCouncilLitigationByAppealSummonId(
            latestAppealSummon?.id || "",
          ).catch((err) => {
            if (isNotFoundError(err)) return [] as CouncilLitigation[];
            throw err;
          });

        setAppealCouncilLitigationData(
          appealCouncilLitigationRes
            ?.slice()
            ?.sort(
              (a, b) =>
                new Date(b?.createdAt ?? "").getTime() -
                new Date(a?.createdAt ?? "").getTime(),
            )
            ?.filter(
              (obj) =>
                obj.summon?.toString() === latestAppealSummon?.id?.toString(),
            ),
        );
      } else {
        setAppealCouncilLitigationData([]);
      }

      if (latestGeneralCouncilSummon) {
        const courtAppealCouncilLitigationRes =
          await fetchAppealCouncilLitigationByAppealSummonId(
            latestGeneralCouncilSummon?.id || "",
          ).catch((err) => {
            if (isNotFoundError(err)) return [] as CouncilLitigation[];
            throw err;
          });

        setCourtAppealCouncilLitigationData(
          courtAppealCouncilLitigationRes
            ?.slice()
            ?.reverse()
            ?.filter(
              (obj) =>
                obj.summon?.toString() ===
                latestGeneralCouncilSummon?.id?.toString(),
            ),
        );
      } else {
        setCourtAppealCouncilLitigationData([]);
      }

      if (latestAppealSummon) {
        const assignmentHistory = await fetchAppealAssignmentHistory().catch(
          (err) => {
            if (isNotFoundError(err)) return [];
            throw err;
          },
        );

        setAssignmentHistoryData(
          assignmentHistory?.filter(
            (obj: any) =>
              obj?.summon_appeal?.toString() ===
              latestAppealSummon?.id?.toString(),
          ),
        );
      } else {
        setAssignmentHistoryData([]);
      }
    } catch (err) {
      showToast(t("failedToLoadComplaint"), "error");
    } finally {
      setIsInitialLoading(false);
    }
  };

  const loadComplaints = useCallback(async () => {
    if (!uu_id) return;
    // setLoading(true);
    try {
      const resData = await fetchComplaintById(uu_id);
      setComplaintData(
        Array.isArray(resData) ? resData?.slice()?.reverse()[0] : resData,
      );
      // setError("");
    } catch (err) {
      // setError("Failed to load complaint.");
    } finally {
      // setLoading(false);
    }
  }, [uu_id]);

  const loadInvestigations = useCallback(async () => {
    if (!complaintData || !uu_id) return;
    // setLoading(true);
    try {
      const resData = await fetchInvestigationByComplaintId(uu_id);
      if (resData) {
        setAllInvestigationData(resData?.slice()?.reverse());
        setInvestigationData(
          Array.isArray(resData) ? resData?.slice()?.reverse()[0] : resData,
        );
        // setError("");
      }
    } catch (err) {
      // setError("Failed to load investigation.");
    } finally {
      // setLoading(false);
    }
  }, [complaintData]);

  const loadSummon = useCallback(async () => {
    if (!investigationData) return;
    // setLoading(true);
    try {
      const resData = await fetchSummonByInvestigationId(
        investigationData?.uu_id || "",
      );
      if (resData)
        setSummonData(
          Array.isArray(resData) ? resData?.slice()?.reverse()[0] : resData,
        );
      // setError("");
    } catch (err) {
      // setError("Failed to load summon.");
    } finally {
      // setLoading(false);
    }
  }, [investigationData]);

  const loadLitigation = useCallback(async () => {
    if (!complaintData || !summonData) return;
    // setLoading(true);
    try {
      await fetchLitigationBySummonId(uu_id || "");
      // setError("");
    } catch (err) {
      // setError("Failed to load summon.");
    } finally {
      // setLoading(false);
    }
  }, [complaintData, summonData]);

  const loadAppeal = useCallback(async () => {
    if (!complaintData || !uu_id) return;
    // setLoading(true);
    try {
      const resData = await fetchAppealByComplaintId(uu_id);
      if (resData) {
        // setAppealData(resData?.slice()?.reverse());
        setCouncilAppealData(
          resData
            ?.sort(
              (a, b) =>
                new Date(b?.createdAt ?? "").getTime() -
                new Date(a?.createdAt ?? "").getTime(),
            )
            ?.filter(
              (obj) =>
                obj.appeal_type ===
                APPEAL_TYPE.INSPECTION_PROSECUTOR_TO_COUNCIL_OFFICE,
            ),
        );

        const data = resData
          ?.sort(
            (a, b) =>
              new Date(b?.createdAt ?? "").getTime() -
              new Date(a?.createdAt ?? "").getTime(),
          )
          ?.filter(
            (obj) =>
              obj.appeal_type === APPEAL_TYPE.ACCUSED_PROSECUTOR_TO_COURT,
          );

        setCourtAppealData(data?.filter((d) => d?.is_appeal_to_court));
        setCourtAppealDataForGeneralCouncil(
          data?.filter((d) => d?.is_appeal_to_general_council),
        );
        setCourtAppealDataForCourt(data?.filter((d) => d?.is_appeal_to_court));
        // setError("");
      }
    } catch (err) {
      // setError("Failed to load investigation.");
    } finally {
      // setLoading(false);
    }
  }, [complaintData]);

  const loadCourtAppealSummonForGeneralCouncil = useCallback(async () => {
    if (!courtAppealDataForGeneralCouncil) return;
    // setLoading(true);
    try {
      const resData = await fetchSummonByAppealId(
        courtAppealDataForGeneralCouncil[0]?.id || "",
      );
      if (resData)
        setCourtAppealSummonDataForGeneralCouncil(
          Array.isArray(resData) ? resData?.slice()?.reverse()[0] : resData,
        );
      // setError("");
    } catch (err) {
      // setError("Failed to load summon.");
    } finally {
      // setLoading(false);
    }
  }, [courtAppealDataForGeneralCouncil]);

  const loadCourtAppealSummon = useCallback(async () => {
    if (!courtAppealDataForCourt) return;
    // setLoading(true);
    try {
      const resData = await fetchSummonByAppealId(
        courtAppealDataForCourt[0]?.id || "",
      );
      if (resData)
        setCourtAppealSummonDataForCourt(
          Array.isArray(resData) ? resData?.slice()?.reverse()[0] : resData,
        );
      // setError("");
    } catch (err) {
      // setError("Failed to load summon.");
    } finally {
      // setLoading(false);
    }
  }, [courtAppealDataForCourt]);

  const loadAppealLitigation = useCallback(async () => {
    if (!complaintData || !appealSummonData) return;
    // setLoading(true);
    try {
      const resData = await fetchAppealLitigationByAppealSummonId(uu_id || "");
      if (resData)
        setAppealLitigationData(
          resData
            ?.slice()
            ?.reverse()
            ?.filter(
              (obj) =>
                obj.summon?.toString() === appealSummonData?.id?.toString(),
            ),
        );
      // setError("");
    } catch (err) {
      // setError("Failed to load summon.");
    } finally {
      // setLoading(false);
    }
  }, [complaintData, appealSummonData]);

  const loadCourtAppealLitigationForGeneralCouncil = useCallback(async () => {
    if (!complaintData) return;
    // setLoading(true);
    try {
      const resData = await fetchAppealLitigationByAppealSummonId(uu_id || "");
      if (resData)
        setCourtAppealLitigationDataForGeneralCouncil(
          resData
            ?.sort(
              (a, b) =>
                new Date(b?.createdAt ?? "").getTime() -
                new Date(a?.createdAt ?? "").getTime(),
            )
            ?.filter((obj) =>
              courtAppealDataForGeneralCouncil &&
              courtAppealDataForGeneralCouncil?.length > 0
                ? obj.appeal_request?.toString() ===
                  courtAppealDataForGeneralCouncil![0]?.id?.toString()
                : courtAppealDataForGeneralCouncil &&
                    courtAppealDataForGeneralCouncil?.length > 0
                  ? obj.appeal_request?.toString() ===
                    courtAppealDataForGeneralCouncil![0]?.id?.toString()
                  : null,
            ),
        );
      // setError("");
    } catch (err) {
      // setError("Failed to load summon.");
    } finally {
      // setLoading(false);
    }
  }, [complaintData, courtAppealDataForGeneralCouncil]);

  const loadCourtAppealLitigationForCourt = useCallback(async () => {
    if (!complaintData) return;
    // setLoading(true);
    try {
      const resData = await fetchAppealLitigationByAppealSummonId(uu_id || "");
      if (resData)
        setCourtAppealLitigationDataForCourt(
          resData
            // ?.slice()
            // .reverse()
            ?.sort(
              (a, b) =>
                new Date(b?.createdAt ?? "").getTime() -
                new Date(a?.createdAt ?? "").getTime(),
            )
            ?.filter((obj) =>
              courtAppealDataForCourt && courtAppealDataForCourt?.length > 0
                ? obj.appeal_request?.toString() ===
                  courtAppealDataForCourt![0]?.id?.toString()
                : courtAppealDataForCourt && courtAppealDataForCourt?.length > 0
                  ? obj.appeal_request?.toString() ===
                    courtAppealDataForCourt![0]?.id?.toString()
                  : null,
            ),
        );
      // setError("");
    } catch (err) {
      // setError("Failed to load summon.");
    } finally {
      // setLoading(false);
    }
  }, [complaintData, courtAppealDataForCourt]);

  const loadAppealCouncilLitigation = useCallback(async () => {
    if (!appealSummonData) return;
    // setLoading(true);
    try {
      const resData = await fetchAppealCouncilLitigationByAppealSummonId(
        appealSummonData?.id || "",
      );
      if (resData)
        setAppealCouncilLitigationData(
          resData
            ?.sort(
              (a, b) =>
                new Date(b?.createdAt ?? "").getTime() -
                new Date(a?.createdAt ?? "").getTime(),
            )
            ?.filter(
              (obj) =>
                obj.summon?.toString() === appealSummonData?.id?.toString(),
            ),
        );
      // setError("");
    } catch (err) {
      // setError("Failed to load summon.");
    } finally {
      // setLoading(false);
    }
  }, [appealSummonData]);

  const loadCourtAppealCouncilLitigation = useCallback(async () => {
    if (!courtAppealSummonDataForGeneralCouncil) return;
    // setLoading(true);
    try {
      const resData = await fetchAppealCouncilLitigationByAppealSummonId(
        courtAppealSummonDataForGeneralCouncil?.id || "",
      );

      if (resData)
        setCourtAppealCouncilLitigationData(
          resData
            ?.slice()
            ?.reverse()
            ?.filter(
              (obj) =>
                obj.summon?.toString() ===
                courtAppealSummonDataForGeneralCouncil?.id?.toString(),
            ),
        );
      // setError("");
    } catch (err) {
      // setError("Failed to load summon.");
    } finally {
      // setLoading(false);
    }
  }, [courtAppealSummonDataForGeneralCouncil]);

  useEffect(() => {
    loadInitialPageData();
  }, [uu_id, user?.admin_unit, user?.access]);

  const handleSendToRegistrarConfirm = async () => {
    if (!councilAppealData || councilAppealData.length === 0) {
      showToast(t("appealNotFound"), "error");
      return;
    }
    setIsSubmitLoading(true);

    const data = {
      appeal_type: councilAppealData[0]?.appeal_type,
      memorandum_summary: councilAppealData[0]?.memorandum_summary,
      requesting_prosecutor: councilAppealData[0]?.requesting_prosecutor,
      discipline_case: councilAppealData[0]?.discipline_case || null,
      appeal_feedback_status: councilAppealData[0]?.appeal_feedback_status,
      appeal_status: APPEAL_STATUS.FORWARDED_TO_REGISTRAR,
      userid_requesting_prosecutor:
        councilAppealData[0]?.userid_requesting_prosecutor,
      assigned_prosecutor: !Array.isArray(complaintData)
        ? complaintData?.user_id_accused_prosecutor_name || ""
        : "",
      user_id_assigned_prosecutor: !Array.isArray(complaintData)
        ? complaintData?.user_id_accused_prosecutor_name || ""
        : "",
      accused_prosecutor_name: !Array.isArray(complaintData)
        ? complaintData?.accused_prosecutor_name || ""
        : "",
      user_id_accused_prosecutor_name: !Array.isArray(complaintData)
        ? complaintData?.user_id_accused_prosecutor_name || ""
        : "",
      accused_prosecutor_org_id: !Array.isArray(complaintData)
        ? complaintData?.accused_prosecutor_org_id || ""
        : "",
      accused_prosecutor_admin_unit_id: !Array.isArray(complaintData)
        ? complaintData?.accused_prosecutor_admin_unit_id || ""
        : "",
      admin_unit_id: !Array.isArray(complaintData)
        ? complaintData?.admin_unit_id || ""
        : "",
      org_id: !Array.isArray(complaintData) ? complaintData?.org_id || "" : "",
    };

    const appeal_id = councilAppealData[0]?.id || "";
    const isFormData = false;

    try {
      await editAppeal(data, appeal_id, isFormData);

      loadAppeal();
      setIsSendToRegistrarModal(false);
      showToast(t("forwardedToRegistrar"), "success");
    } catch (err: any) {
      console.error("Submission error:", err);
      showToast(t("submissionError"), "error");
    } finally {
      // setLoading(false);
    }
  };

  const handleCourtSendToRegistrarConfirm = async () => {
    if (!courtAppealData || courtAppealData.length === 0) {
      showToast(t("appealNotFound"), "error");
      return;
    }
    setIsSubmitLoading(true);

    const data = {
      appeal_type: courtAppealData[0]?.appeal_type,
      memorandum_summary: courtAppealData[0]?.memorandum_summary,
      requesting_prosecutor: courtAppealData[0]?.requesting_prosecutor,
      discipline_case: courtAppealData[0]?.discipline_case || null,
      appeal_feedback_status: courtAppealData[0]?.appeal_feedback_status,
      appeal_status: APPEAL_STATUS.FORWARDED_TO_REGISTRAR,

      userid_requesting_prosecutor:
        courtAppealData[0]?.userid_requesting_prosecutor,
      assigned_prosecutor: !Array.isArray(complaintData)
        ? complaintData?.user_id_accused_prosecutor_name || ""
        : "",
      user_id_assigned_prosecutor: !Array.isArray(complaintData)
        ? complaintData?.user_id_accused_prosecutor_name || ""
        : "",
      accused_prosecutor_name: !Array.isArray(complaintData)
        ? complaintData?.accused_prosecutor_name || ""
        : "",
      user_id_accused_prosecutor_name: !Array.isArray(complaintData)
        ? complaintData?.user_id_accused_prosecutor_name || ""
        : "",
      accused_prosecutor_org_id: !Array.isArray(complaintData)
        ? complaintData?.accused_prosecutor_org_id || ""
        : "",
      accused_prosecutor_admin_unit_id: !Array.isArray(complaintData)
        ? complaintData?.accused_prosecutor_admin_unit_id || ""
        : "",
      admin_unit_id: !Array.isArray(complaintData)
        ? complaintData?.admin_unit_id || ""
        : "",
      org_id: !Array.isArray(complaintData) ? complaintData?.org_id || "" : "",
    };

    const appeal_id = courtAppealData[0]?.id || "";
    const isFormData = false;

    try {
      await editAppeal(data, appeal_id, isFormData);

      loadAppeal();
      setIsSendToRegistrarModal(false);
      showToast(t("forwardedToRegistrar"), "success");
    } catch (err: any) {
      console.error("Submission error:", err);
      showToast(t("submissionError"), "error");
    } finally {
      // setLoading(false);
    }
  };

  const handleSendToCouncilConfirm = async () => {
    if (!councilAppealData || councilAppealData.length === 0) {
      showToast(t("appealNotFound"), "error");
      return;
    }

    setIsSubmitLoading(true);

    const data = {
      appeal_type: councilAppealData[0]?.appeal_type,
      memorandum_summary: councilAppealData[0]?.memorandum_summary,
      requesting_prosecutor: councilAppealData[0]?.requesting_prosecutor,
      discipline_case: councilAppealData[0]?.discipline_case || null,
      appeal_feedback_status: councilAppealData[0]?.appeal_feedback_status,
      appeal_status: APPEAL_STATUS.FORWARDED_TO_COUNCIL,

      admin_unit_id:
        adminUnitData?.hierarchy_level?.name === HIERARCHY_LEVELS.ZONAL
          ? adminUnitData?.parent_unit || ""
          : councilAppealData[0]?.admin_unit_id || "",
      userid_requesting_prosecutor:
        councilAppealData[0]?.userid_requesting_prosecutor,
      assigned_prosecutor: !Array.isArray(complaintData)
        ? complaintData?.user_id_accused_prosecutor_name || ""
        : "",
      user_id_assigned_prosecutor: !Array.isArray(complaintData)
        ? complaintData?.user_id_accused_prosecutor_name || ""
        : "",
      accused_prosecutor_name: !Array.isArray(complaintData)
        ? complaintData?.accused_prosecutor_name || ""
        : "",
      user_id_accused_prosecutor_name: !Array.isArray(complaintData)
        ? complaintData?.user_id_accused_prosecutor_name || ""
        : "",
      accused_prosecutor_org_id: !Array.isArray(complaintData)
        ? complaintData?.accused_prosecutor_org_id || ""
        : "",
      accused_prosecutor_admin_unit_id: !Array.isArray(complaintData)
        ? complaintData?.accused_prosecutor_admin_unit_id || ""
        : "",
      org_id: !Array.isArray(complaintData) ? complaintData?.org_id || "" : "",
    };

    const appeal_id = councilAppealData[0]?.id || "";
    const isFormData = false;

    try {
      const resData = await editAppeal(data, appeal_id, isFormData);

      if (resData) {
        await editComplaint({
          ...(complaintData as Complaints),
          has_councileappeal: true,
          admin_unit_id:
            adminUnitData?.hierarchy_level?.name === HIERARCHY_LEVELS.ZONAL
              ? adminUnitData?.parent_unit || ""
              : councilAppealData[0]?.admin_unit_id || "",
        });
      }

      loadAppeal();
      setIsSendToCouncilModal(false);
      showToast(t("forwardedToCouncil"), "success");
    } catch (err: any) {
      console.error("Submission error:", err);
      showToast(t("submissionError"), "error");
    } finally {
      // setLoading(false);
    }
  };

  const handleGeneratlCouncilSendToCouncilConfirm = async () => {
    if (
      !courtAppealDataForGeneralCouncil ||
      courtAppealDataForGeneralCouncil.length === 0
    ) {
      showToast(t("appealNotFound"), "error");
      return;
    }
    setIsSubmitLoading(true);

    const data = {
      appeal_type: courtAppealDataForGeneralCouncil[0]?.appeal_type,
      memorandum_summary:
        courtAppealDataForGeneralCouncil[0]?.memorandum_summary,
      requesting_prosecutor:
        courtAppealDataForGeneralCouncil[0]?.requesting_prosecutor,
      discipline_case:
        courtAppealDataForGeneralCouncil[0]?.discipline_case || null,
      appeal_feedback_status:
        courtAppealDataForGeneralCouncil[0]?.appeal_feedback_status,
      appeal_status: APPEAL_STATUS.FORWARDED_TO_COUNCIL,

      userid_requesting_prosecutor:
        courtAppealDataForGeneralCouncil[0]?.userid_requesting_prosecutor,
      assigned_prosecutor: !Array.isArray(complaintData)
        ? complaintData?.user_id_accused_prosecutor_name || ""
        : "",
      user_id_assigned_prosecutor: !Array.isArray(complaintData)
        ? complaintData?.user_id_accused_prosecutor_name || ""
        : "",
      accused_prosecutor_name: !Array.isArray(complaintData)
        ? complaintData?.accused_prosecutor_name || ""
        : "",
      user_id_accused_prosecutor_name: !Array.isArray(complaintData)
        ? complaintData?.user_id_accused_prosecutor_name || ""
        : "",
      accused_prosecutor_org_id: !Array.isArray(complaintData)
        ? complaintData?.accused_prosecutor_org_id || ""
        : "",
      accused_prosecutor_admin_unit_id: !Array.isArray(complaintData)
        ? complaintData?.accused_prosecutor_admin_unit_id || ""
        : "",
      admin_unit_id: !Array.isArray(complaintData)
        ? complaintData?.admin_unit_id || ""
        : "",
      org_id: !Array.isArray(complaintData) ? complaintData?.org_id || "" : "",
    };

    const appeal_id = courtAppealDataForGeneralCouncil[0]?.id || "";
    const isFormData = false;

    try {
      const resData = await editAppeal(data, appeal_id, isFormData);

      if (resData) {
        await editComplaint({
          ...(complaintData as Complaints),
          has_appeal: true,
          has_councileappeal: true,
        });
      }

      loadAppeal();
      setIsSendToCouncilModal(false);
      showToast(t("forwardedToCouncil"), "success");
    } catch (err: any) {
      console.error("Submission error:", err);
      showToast(t("submissionError"), "error");
    } finally {
      // setLoading(false);
    }
  };

  const handleCourtSendToCouncilConfirm = async () => {
    if (!courtAppealDataForCourt || courtAppealDataForCourt.length === 0) {
      showToast(t("appealNotFound"), "error");
      return;
    }
    setIsSubmitLoading(true);

    const data = {
      appeal_type: courtAppealDataForCourt[0]?.appeal_type,
      memorandum_summary: courtAppealDataForCourt[0]?.memorandum_summary,
      requesting_prosecutor: courtAppealDataForCourt[0]?.requesting_prosecutor,
      discipline_case: courtAppealDataForCourt[0]?.discipline_case || null,
      appeal_feedback_status:
        courtAppealDataForCourt[0]?.appeal_feedback_status,
      appeal_status: APPEAL_STATUS.FORWARDED_TO_COUNCIL,

      userid_requesting_prosecutor:
        courtAppealDataForCourt[0]?.userid_requesting_prosecutor,
      assigned_prosecutor: !Array.isArray(complaintData)
        ? complaintData?.user_id_accused_prosecutor_name || ""
        : "",
      user_id_assigned_prosecutor: !Array.isArray(complaintData)
        ? complaintData?.user_id_accused_prosecutor_name || ""
        : "",
      accused_prosecutor_name: !Array.isArray(complaintData)
        ? complaintData?.accused_prosecutor_name || ""
        : "",
      user_id_accused_prosecutor_name: !Array.isArray(complaintData)
        ? complaintData?.user_id_accused_prosecutor_name || ""
        : "",
      accused_prosecutor_org_id: !Array.isArray(complaintData)
        ? complaintData?.accused_prosecutor_org_id || ""
        : "",
      accused_prosecutor_admin_unit_id: !Array.isArray(complaintData)
        ? complaintData?.accused_prosecutor_admin_unit_id || ""
        : "",
      admin_unit_id: !Array.isArray(complaintData)
        ? complaintData?.admin_unit_id || ""
        : "",
      org_id: !Array.isArray(complaintData) ? complaintData?.org_id || "" : "",
    };

    const appeal_id = courtAppealDataForCourt[0]?.id || "";
    const isFormData = false;

    try {
      const resData = await editAppeal(data, appeal_id, isFormData);

      if (resData) {
        await editComplaint({
          ...(complaintData as Complaints),
          has_appeal: true,
          has_councileappeal: true,
        });
      }

      loadAppeal();
      setIsSendToCouncilModal(false);
      showToast(t("forwardedToCouncil"), "success");
    } catch (err: any) {
      console.error("Submission error:", err);
      showToast(t("submissionError"), "error");
    } finally {
      // setLoading(false);
    }
  };

  const handleRejectAppeal = async () => {
    if (!councilAppealData || councilAppealData.length === 0) {
      showToast(t("appealNotFound"), "error");
      return;
    }

    setIsSubmitLoading(true);
    const data = {
      appeal_type: councilAppealData[0]?.appeal_type,
      memorandum_summary: councilAppealData[0]?.memorandum_summary,
      requesting_prosecutor: councilAppealData[0]?.requesting_prosecutor,
      discipline_case: councilAppealData[0]?.discipline_case || null,
      appeal_status: APPEAL_STATUS.REJECTED,

      userid_requesting_prosecutor:
        councilAppealData[0]?.userid_requesting_prosecutor,
      assigned_prosecutor: !Array.isArray(complaintData)
        ? complaintData?.user_id_accused_prosecutor_name || ""
        : "",
      user_id_assigned_prosecutor: !Array.isArray(complaintData)
        ? complaintData?.user_id_accused_prosecutor_name || ""
        : "",
      accused_prosecutor_name: !Array.isArray(complaintData)
        ? complaintData?.accused_prosecutor_name || ""
        : "",
      user_id_accused_prosecutor_name: !Array.isArray(complaintData)
        ? complaintData?.user_id_accused_prosecutor_name || ""
        : "",
      accused_prosecutor_org_id: !Array.isArray(complaintData)
        ? complaintData?.accused_prosecutor_org_id || ""
        : "",
      accused_prosecutor_admin_unit_id: !Array.isArray(complaintData)
        ? complaintData?.accused_prosecutor_admin_unit_id || ""
        : "",
      admin_unit_id: !Array.isArray(complaintData)
        ? complaintData?.admin_unit_id || ""
        : "",
      org_id: !Array.isArray(complaintData) ? complaintData?.org_id || "" : "",
    };

    const appeal_id = councilAppealData[0]?.id || "";
    const isFormData = false;

    try {
      await editAppeal(data, appeal_id, isFormData);

      loadAppeal();
      setIsRejectAppealOpen(false);
      showToast(t("successfullyCreated"), "success");
    } catch (err: any) {
      console.error("Submission error:", err);
      showToast(t("submissionError"), "error");
    } finally {
      // setLoading(false);
    }
  };

  const handleCourtRejectAppeal = async () => {
    if (!courtAppealData || courtAppealData.length === 0) {
      showToast(t("appealNotFound"), "error");
      return;
    }

    setIsSubmitLoading(true);
    const data = {
      appeal_type: courtAppealData[0]?.appeal_type,
      memorandum_summary: courtAppealData[0]?.memorandum_summary,
      requesting_prosecutor: courtAppealData[0]?.requesting_prosecutor,
      discipline_case: courtAppealData[0]?.discipline_case || null,
      appeal_status: APPEAL_STATUS.REJECTED,

      userid_requesting_prosecutor:
        courtAppealData[0]?.userid_requesting_prosecutor,
      assigned_prosecutor: !Array.isArray(complaintData)
        ? complaintData?.user_id_accused_prosecutor_name || ""
        : "",
      user_id_assigned_prosecutor: !Array.isArray(complaintData)
        ? complaintData?.user_id_accused_prosecutor_name || ""
        : "",
      accused_prosecutor_name: !Array.isArray(complaintData)
        ? complaintData?.accused_prosecutor_name || ""
        : "",
      user_id_accused_prosecutor_name: !Array.isArray(complaintData)
        ? complaintData?.user_id_accused_prosecutor_name || ""
        : "",
      accused_prosecutor_org_id: !Array.isArray(complaintData)
        ? complaintData?.accused_prosecutor_org_id || ""
        : "",
      accused_prosecutor_admin_unit_id: !Array.isArray(complaintData)
        ? complaintData?.accused_prosecutor_admin_unit_id || ""
        : "",
      admin_unit_id: !Array.isArray(complaintData)
        ? complaintData?.admin_unit_id || ""
        : "",
      org_id: !Array.isArray(complaintData) ? complaintData?.org_id || "" : "",
    };

    const appeal_id = courtAppealData[0]?.id || "";
    const isFormData = false;

    try {
      await editAppeal(data, appeal_id, isFormData);

      loadAppeal();
      setIsRejectAppealOpen(false);
      showToast(t("successfullyCreated"), "success");
    } catch (err: any) {
      console.error("Submission error:", err);
      showToast(t("submissionError"), "error");
    } finally {
      // setLoading(false);
    }
  };

  return (
    <div className="min-h-screen">
      <h1 className="text-2xl font-semibold text-gray-700 flex items-center gap-2 mb-5">
        <span>💼</span>
        {t("appealDetail")}
      </h1>

      {/* Header: Tabs */}
      <div className="w-full flex flex-wrap items-center justify-between gap-4 mb-5">
        <TabNav active={activeTab} tabs={tabs} onSelect={setActiveTab} />

        <div className="text-right">
          {activeTab === tabs[1] && (
            <div className="flex gap-4">
              {canSendAppealToCouncil &&
                councilAppealData &&
                councilAppealData?.length > 0 &&
                councilAppealData[0]?.appeal_status ===
                  APPEAL_STATUS.FORWARDED_TO_REGISTRAR &&
                councilAppealData[0]?.registration_number && (
                  <button
                    className="bg-green-600 text-white px-8 py-2 rounded-md hover:bg-gray-800"
                    type="submit"
                    onClick={() => setIsSendToCouncilModal(true)}
                  >
                    {t("sendToCouncil")}
                  </button>
                )}

              {canCreateAppealSummon &&
                councilAppealData &&
                councilAppealData?.length > 0 &&
                councilAppealData[0]?.appeal_status ===
                  APPEAL_STATUS.FORWARDED_TO_COUNCIL &&
                councilAppealData[0]?.admin_unit_id?.toString() ===
                  user?.admin_unit?.toString() &&
                !appealSummonData &&
                (complaintData as Complaints)?.status !==
                  COMPLIANT_STATUS.APPEAL_REJECTED_FOR_INSPECTION && (
                  <button
                    className="bg-green-700 text-white px-8 py-2 rounded-md hover:bg-gray-800"
                    type="submit"
                    onClick={() => setIsAppealSummonOpen(true)}
                  >
                    {t("createAppealSummon")}
                  </button>
                )}

              {canCreateAppealSummon &&
                councilAppealData &&
                councilAppealData?.length > 0 &&
                councilAppealData[0]?.appeal_status ===
                  APPEAL_STATUS.FORWARDED_TO_COUNCIL &&
                councilAppealData[0]?.admin_unit_id?.toString() ===
                  user?.admin_unit?.toString() &&
                !appealSummonData &&
                councilAppealData[0]?.council_office_verdicts?.length === 0 &&
                (complaintData as Complaints)?.status !==
                  COMPLIANT_STATUS.APPEAL_REJECTED_FOR_INSPECTION && (
                  <button
                    className="bg-green-700 text-white px-8 py-2 rounded-md hover:bg-gray-800"
                    type="submit"
                    onClick={() =>
                      canCreateCouncilDailyHearing &&
                      appealCouncilLitigationData?.length === 0
                        ? setIsDailyHearingOpen(true)
                        : setIsInitialHearingDecisionOpen(true)
                    }
                  >
                    {canCreateCouncilDailyHearing &&
                    appealCouncilLitigationData?.length === 0
                      ? t("addInitialHearing")
                      : t("addDecision")}
                  </button>
                )}
              {/* {canCreateAppealSummon &&
                councilAppealData &&
                councilAppealData?.length > 0 &&
                councilAppealData[0]?.appeal_status ===
                  APPEAL_STATUS.FORWARDED_TO_COUNCIL &&
                councilAppealData[0]?.admin_unit_id?.toString() ===
                  user?.admin_unit?.toString() &&
                !appealSummonData &&
                councilAppealData &&
                complaintData &&
                (complaintData as Complaints)?.status !==
                  COMPLIANT_STATUS.APPEAL_REJECTED_FOR_INSPECTION && (
                  <button
                    className="bg-red-700 text-white px-8 py-2 rounded-md hover:bg-gray-800"
                    type="submit"
                    onClick={() => setIsAppealRejectOpen(true)}
                    // onClick={() => setIsRejectAppealOpen(true)}
                  >
                    {t("rejectAppeal")}
                  </button>
                )} */}
            </div>
          )}

          {activeTab === tabs[2] && (
            <div className="flex gap-4">
              {
                // appealSummonData?.accused_confirmed &&
                appealSummonData?.cordinator_confirmed &&
                  ((canCreateInspectionDailyHearing &&
                    (!appealLitigationData ||
                      (appealLitigationData &&
                        !appealLitigationData[0]?.is_final_verdict_given))) ||
                    (canCreateCouncilDailyHearing &&
                      councilAppealData &&
                      councilAppealData?.length > 0 &&
                      councilAppealData[0]?.admin_unit_id?.toString() ===
                        user?.admin_unit?.toString() &&
                      (!appealCouncilLitigationData ||
                        (appealCouncilLitigationData &&
                          !appealCouncilLitigationData[0]
                            ?.is_final_verdict_given)))) && (
                    <button
                      className="bg-red-700 text-white px-8 py-2 rounded-md hover:bg-gray-800"
                      type="submit"
                      onClick={() => setIsDailyHearingOpen(true)}
                    >
                      {canCreateCouncilDailyHearing &&
                      appealCouncilLitigationData?.length === 0
                        ? t("addInitialHearing")
                        : t("addDailyHearing")}
                    </button>
                  )
              }

              {canCreateLitigationDecision &&
                appealLitigationData &&
                appealLitigationData[0]?.is_final_verdict_given &&
                !appealLitigationData[0]?.council_decision_summary && (
                  // councilLitigationData &&
                  // councilLitigationData[0]?.is_final_verdict_given &&
                  // (councilLitigationData[0]?.council_decision_summary ||
                  //   councilLitigationData[0]?.council_decision) &&
                  <button
                    className="bg-red-700 text-white px-8 py-2 rounded-md hover:bg-gray-800"
                    type="submit"
                    onClick={() => setIsLitigationDecisionOpen(true)}
                  >
                    {t("addAppealLitigationDecision")}
                  </button>
                )}

              {canCreateCouncilLitigationDecision &&
                councilAppealData &&
                councilAppealData?.length > 0 &&
                councilAppealData[0]?.admin_unit_id?.toString() ===
                  user?.admin_unit?.toString() &&
                appealCouncilLitigationData &&
                appealCouncilLitigationData[0]?.is_final_verdict_given &&
                !appealCouncilLitigationData[0]?.council_decision_summary && (
                  <button
                    className="bg-red-700 text-white px-8 py-2 rounded-md hover:bg-gray-800"
                    type="submit"
                    onClick={() => setIsCouncilLitigationDecisionOpen(true)}
                  >
                    {t("addCouncilOfficeDecision")}
                  </button>
                )}

              {canAppealToCourt &&
                (courtAppealDataForGeneralCouncil?.length ?? 0) <= 0 &&
                appealLitigationData &&
                // appealLitigationData[0]
                //   ?.prosecutor_opinion_on_decision_appeal ==
                //   PROSECUTOR_APPEAL_OPINION.APPEAL &&
                appealCouncilLitigationData &&
                appealCouncilLitigationData[0]?.is_final_verdict_given &&
                (appealCouncilLitigationData[0]?.council_decision_summary ||
                  appealCouncilLitigationData[0]?.council_decision) && (
                  <button
                    className="bg-red-700 text-white px-8 py-2 rounded-md hover:bg-gray-800"
                    type="submit"
                    onClick={() => setIsAppealGeneralCouncilOpen(true)}
                  >
                    {t("appealToGeneralCouncil")}
                  </button>
                )}

              {/* Inspection Litigation Termination */}
              {/* {canTerminateInspectionLitigation &&
                appealLitigationData &&
                !appealLitigationData[0]?.termination_reason &&
                appealLitigationData[0]?.is_final_verdict_given && (
                  <button
                    className="bg-red-900 text-white px-8 py-2 rounded-md hover:bg-gray-800"
                    type="submit"
                    onClick={() => setIsTerminateOpen(true)}
                  >
                    {t("terminate")}
                  </button>
                )} */}

              {/* Council Litigation Termination */}
              {/* {canTerminateCouncilLitigation &&
                appealCouncilLitigationData &&
                !appealCouncilLitigationData[0]?.termination_reason &&
                appealCouncilLitigationData[0]?.is_final_verdict_given && (
                  <button
                    className="bg-red-700 text-white px-8 py-2 rounded-md hover:bg-gray-800"
                    type="submit"
                    onClick={() => setIsTerminateOpen(true)}
                  >
                    {t("terminate")}
                  </button>
                )} */}
            </div>
          )}

          {activeTab === tabs[3] && (
            <div className="flex gap-4">
              {/* {canSendAppealToRegistrar &&
                courtAppealDataForGeneralCouncil &&
                courtAppealDataForGeneralCouncil?.length > 0 &&
                courtAppealDataForGeneralCouncil[0]?.appeal_status ===
                  APPEAL_STATUS.APPROVED && (
                  <button
                    className="bg-green-600 text-white px-8 py-2 rounded-md hover:bg-gray-800"
                    type="submit"
                    onClick={() => setIsSendToRegistrarModal(true)}
                  >
                    {t("sendToRegistrar")}
                  </button>
                )} */}

              {/* MULTIPLE TIMES ASKING COURT APPEAL */}
              {/* {canAppealToCourt &&
                courtAppealLitigationData &&
                courtAppealLitigationData[0]?.council_decision_summary && (
                  <button
                    className="bg-red-700 text-white px-8 py-2 rounded-md hover:bg-gray-800"
                    type="submit"
                    onClick={() => setIsAppealCourtOpen(true)}
                  >
                    {t("appealToCourt")}
                  </button>
                )} */}

              {canSendAppealToCouncil &&
                courtAppealDataForGeneralCouncil &&
                courtAppealDataForGeneralCouncil?.length > 0 &&
                courtAppealDataForGeneralCouncil[0]?.appeal_status ===
                  APPEAL_STATUS.FORWARDED_TO_REGISTRAR &&
                courtAppealDataForGeneralCouncil[0]?.registration_number && (
                  <button
                    className="bg-green-600 text-white px-8 py-2 rounded-md hover:bg-gray-800"
                    type="submit"
                    onClick={() => setIsSendToCouncilModal(true)}
                  >
                    {t("sendToCouncil")}
                  </button>
                )}

              {/* {canCreateAppealSummon &&
                courtAppealData &&
                courtAppealData?.length > 0 &&
                courtAppealData[0]?.appeal_status ==
                  APPEAL_STATUS.FORWARDED_TO_COUNCIL &&
                !courtAppealSummonData && (
                  <button
                    className="bg-red-700 text-white px-8 py-2 rounded-md hover:bg-gray-800"
                    type="submit"
                    onClick={() => setIsRejectAppealOpen(true)}
                  >
                    {t("rejectAppeal")}
                  </button>
                )} */}

              {isRegionalCouncilOfficeHead &&
                courtAppealDataForGeneralCouncil &&
                courtAppealDataForGeneralCouncil?.length > 0 &&
                courtAppealDataForGeneralCouncil[0]?.appeal_status ===
                  APPEAL_STATUS.FORWARDED_TO_COUNCIL &&
                !courtAppealSummonDataForGeneralCouncil && (
                  <button
                    className="bg-green-700 text-white px-8 py-2 rounded-md hover:bg-gray-800"
                    type="submit"
                    onClick={() => setIsAppealSummonOpen(true)}
                  >
                    {t("createAppealSummon")}
                  </button>
                )}

              {isRegionalCouncilOfficeHead &&
                courtAppealDataForGeneralCouncil &&
                courtAppealDataForGeneralCouncil?.length > 0 &&
                courtAppealDataForGeneralCouncil[0]?.appeal_status ===
                  APPEAL_STATUS.FORWARDED_TO_COUNCIL &&
                !courtAppealSummonDataForGeneralCouncil && (
                  <button
                    className="bg-green-700 text-white px-8 py-2 rounded-md hover:bg-gray-800"
                    type="submit"
                    onClick={() =>
                      canCreateCouncilDailyHearing &&
                      appealCouncilLitigationData?.length === 0
                        ? setIsDailyHearingOpen(true)
                        : setIsInitialHearingDecisionOpen(true)
                    }
                  >
                    {canCreateCouncilDailyHearing &&
                    appealCouncilLitigationData?.length === 0
                      ? t("addInitialHearing")
                      : t("addDecision")}
                  </button>
                )}
            </div>
          )}

          {activeTab === tabs[4] && (
            <div className="flex gap-4">
              {
                // appealSummonData?.accused_confirmed &&
                // courtAppealSummonData?.cordinator_confirmed &&
                //   canCreateInspectionDailyHearing &&
                //   courtAppealDataForGeneralCouncil &&
                //   courtAppealDataForGeneralCouncil?.length > 0 &&
                //   // courtAppealDataForGeneralCouncil[0]?.appeal_status ==
                //   //   APPEAL_STATUS.FORWARDED_TO_COUNCIL &&
                //   courtAppealDataForGeneralCouncil[0]?.registration_number &&
                //   (!courtAppealLitigationData ||
                //     (courtAppealLitigationData &&
                //       !courtAppealLitigationData[0]
                //         ?.is_final_verdict_given)) && (

                appealSummonData?.cordinator_confirmed &&
                  // ((canCreateInspectionDailyHearing &&
                  //   (!courtAppealLitigationData ||
                  //     (courtAppealLitigationData &&
                  //       !courtAppealLitigationData[0]
                  //         ?.is_final_verdict_given))) ||
                  //   (isRegionalCouncilOfficeHead &&
                  //     courtAppealDataForGeneralCouncil &&
                  //     courtAppealCouncilLitigationData &&
                  //     !courtAppealCouncilLitigationData[0]
                  //       ?.is_final_verdict_given &&
                  //     courtAppealDataForGeneralCouncil?.length > 0 &&
                  //     courtAppealDataForGeneralCouncil[0]?.admin_unit_id?.toString() ===
                  //       user?.admin_unit?.toString() &&
                  //     (courtAppealCouncilLitigationData?.length === 0 ||
                  //       (courtAppealCouncilLitigationData &&
                  //         !courtAppealCouncilLitigationData[0]
                  //           ?.is_final_verdict_given)))) && (

                  courtAppealDataForGeneralCouncil &&
                  courtAppealSummonDataForGeneralCouncil &&
                  courtAppealDataForGeneralCouncil[0]?.registration_number &&
                  ((canCreateInspectionDailyHearing &&
                    (!courtAppealLitigationDataForGeneralCouncil ||
                      (courtAppealLitigationDataForGeneralCouncil &&
                        !courtAppealLitigationDataForGeneralCouncil[0]
                          ?.is_final_verdict_given))) ||
                    (isRegionalCouncilOfficeHead &&
                      courtAppealDataForGeneralCouncil &&
                      courtAppealDataForGeneralCouncil?.length > 0 &&
                      courtAppealDataForGeneralCouncil[0]?.admin_unit_id?.toString() ===
                        user?.admin_unit?.toString() &&
                      (!courtAppealCouncilLitigationData ||
                        (courtAppealCouncilLitigationData &&
                          !courtAppealCouncilLitigationData[0]
                            ?.is_final_verdict_given)))) && (
                    <button
                      className="bg-red-700 text-white px-8 py-2 rounded-md hover:bg-gray-800"
                      type="submit"
                      onClick={() => setIsDailyHearingOpen(true)}
                    >
                      {canCreateCouncilDailyHearing &&
                      courtAppealDataForGeneralCouncil?.length === 0
                        ? t("addInitialHearing")
                        : t("addDailyHearing")}{" "}
                    </button>
                  )
              }

              {
                // (canCreateLitigationDecision || canCreateCouncilDailyHearing) &&
                //   courtAppealLitigationData &&
                //   courtAppealLitigationData[0]?.is_final_verdict_given &&
                //   !courtAppealLitigationData[0]?.council_decision_summary && (
                ((canCreateLitigationDecision &&
                  courtAppealLitigationDataForGeneralCouncil &&
                  courtAppealLitigationDataForGeneralCouncil[0]
                    ?.is_final_verdict_given &&
                  !courtAppealLitigationDataForGeneralCouncil[0]
                    ?.council_decision_summary &&
                  !courtAppealLitigationDataForGeneralCouncil[0]
                    ?.council_decision &&
                  councilLitigationData &&
                  councilLitigationData[0]?.is_final_verdict_given &&
                  (councilLitigationData[0]?.council_decision_summary ||
                    councilLitigationData[0]?.council_decision)) ||
                  (isRegionalCouncilOfficeHead &&
                    courtAppealCouncilLitigationData &&
                    courtAppealCouncilLitigationData[0]
                      ?.is_final_verdict_given &&
                    !courtAppealCouncilLitigationData[0]
                      ?.council_decision_summary &&
                    !courtAppealCouncilLitigationData[0]
                      ?.council_decision)) && (
                  <button
                    className="bg-red-700 text-white px-8 py-2 rounded-md hover:bg-gray-800"
                    type="submit"
                    onClick={() => setIsLitigationDecisionOpen(true)}
                  >
                    {t("addAppealLitigationDecision")}
                  </button>
                )
              }
              {/* Inspection Litigation Termination */}
              {/* {canTerminateInspectionLitigation &&
                courtAppealLitigationData &&
                !courtAppealLitigationData[0]?.termination_reason &&
                courtAppealLitigationData[0]?.is_final_verdict_given && (
                  <button
                    className="bg-red-900 text-white px-8 py-2 rounded-md hover:bg-gray-800"
                    type="submit"
                    onClick={() => setIsTerminateOpen(true)}
                  >
                    {t("terminate")}
                  </button>
                )} */}
              {canAppealToCourt &&
                (courtAppealDataForCourt?.length ?? 0) <= 0 &&
                appealLitigationData &&
                // -----------------
                courtAppealCouncilLitigationData &&
                courtAppealCouncilLitigationData[0]?.is_final_verdict_given &&
                courtAppealCouncilLitigationData[0]?.council_decision_summary &&
                // -----------------
                courtAppealLitigationDataForGeneralCouncil &&
                courtAppealLitigationDataForGeneralCouncil[0]
                  ?.is_final_verdict_given &&
                courtAppealLitigationDataForGeneralCouncil[0]
                  ?.council_decision_summary && (
                  // -----------------
                  // appealLitigationData[0]
                  //   ?.prosecutor_opinion_on_decision_appeal ==
                  //   PROSECUTOR_APPEAL_OPINION.APPEAL &&
                  // appealCouncilLitigationData &&
                  // appealCouncilLitigationData[0]?.is_final_verdict_given &&
                  // (appealCouncilLitigationData[0]?.council_decision_summary ||
                  //   appealCouncilLitigationData[0]?.council_decision)&&

                  <button
                    className="bg-red-700 text-white px-8 py-2 rounded-md hover:bg-gray-800"
                    type="submit"
                    onClick={() => setIsAppealCourtOpen(true)}
                  >
                    {t("appealToCourt")}
                  </button>
                )}
            </div>
          )}

          {activeTab === tabs[5] && (
            <div className="flex gap-4">
              {canSendAppealToRegistrar &&
                courtAppealDataForCourt &&
                courtAppealDataForCourt?.length > 0 &&
                courtAppealDataForCourt[0]?.appeal_status ===
                  APPEAL_STATUS.APPROVED && (
                  <button
                    className="bg-green-600 text-white px-8 py-2 rounded-md hover:bg-gray-800"
                    type="submit"
                    onClick={() => setIsSendToRegistrarModal(true)}
                  >
                    {t("sendToRegistrar")}
                  </button>
                )}

              {/* MULTIPLE TIMES ASKING COURT APPEAL */}
              {/* {canAppealToCourt &&
                courtAppealLitigationData &&
                courtAppealLitigationData[0]?.council_decision_summary && (
                  <button
                    className="bg-red-700 text-white px-8 py-2 rounded-md hover:bg-gray-800"
                    type="submit"
                    onClick={() => setIsAppealCourtOpen(true)}
                  >
                    {t("appealToCourt")}
                  </button>
                )} */}

              {/* {canSendAppealToCouncil &&
                courtAppealData &&
                courtAppealData?.length > 0 &&
                courtAppealData[0]?.appeal_status ==
                  APPEAL_STATUS.FORWARDED_TO_REGISTRAR &&
                courtAppealData[0]?.registration_number && (
                  <button
                    className="bg-green-600 text-white px-8 py-2 rounded-md hover:bg-gray-800"
                    type="submit"
                    onClick={() => setIsSendToCouncilModal(true)}
                  >
                    {t("sendToCouncil")}
                  </button>
                )} */}

              {/* {canCreateAppealSummon &&
                courtAppealData &&
                courtAppealData?.length > 0 &&
                courtAppealData[0]?.appeal_status ==
                  APPEAL_STATUS.FORWARDED_TO_COUNCIL &&
                !courtAppealSummonData && (
                  <button
                    className="bg-red-700 text-white px-8 py-2 rounded-md hover:bg-gray-800"
                    type="submit"
                    onClick={() => setIsRejectAppealOpen(true)}
                  >
                    {t("rejectAppeal")}
                  </button>
                )} */}

              {/* {canCreateAppealSummon &&
                courtAppealData &&
                courtAppealData?.length > 0 &&
                courtAppealData[0]?.appeal_status ==
                  APPEAL_STATUS.FORWARDED_TO_COUNCIL &&
                !courtAppealSummonData && (
                  <button
                    className="bg-green-700 text-white px-8 py-2 rounded-md hover:bg-gray-800"
                    type="submit"
                    onClick={() => setIsAppealSummonOpen(true)}
                  >
                    {t("createAppealSummon")}
                  </button>
                )} */}
            </div>
          )}

          {activeTab === tabs[6] && (
            <div className="flex gap-4">
              {
                // appealSummonData?.accused_confirmed &&
                // courtAppealSummonData?.cordinator_confirmed &&
                canCreateInspectionDailyHearing &&
                  courtAppealDataForCourt &&
                  courtAppealDataForCourt?.length > 0 &&
                  // courtAppealDataForCourt[0]?.appeal_status ==
                  //   APPEAL_STATUS.FORWARDED_TO_COUNCIL &&
                  courtAppealDataForCourt[0]?.registration_number &&
                  (!courtAppealLitigationDataForCourt ||
                    (courtAppealLitigationDataForCourt &&
                      !courtAppealLitigationDataForCourt[0]
                        ?.is_final_verdict_given)) && (
                    <button
                      className="bg-red-700 text-white px-8 py-2 rounded-md hover:bg-gray-800"
                      type="submit"
                      onClick={() => setIsDailyHearingOpen(true)}
                    >
                      {t("addDailyHearing")}
                    </button>
                  )
              }

              {canCreateLitigationDecision &&
                courtAppealLitigationDataForCourt &&
                courtAppealLitigationDataForCourt[0]?.is_final_verdict_given &&
                !courtAppealLitigationDataForCourt[0]
                  ?.council_decision_summary &&
                !courtAppealLitigationDataForCourt[0]?.council_decision && (
                  // councilLitigationData &&
                  // councilLitigationData[0]?.is_final_verdict_given &&
                  // (councilLitigationData[0]?.council_decision_summary ||
                  //   councilLitigationData[0]?.council_decision) &&
                  <button
                    className="bg-red-700 text-white px-8 py-2 rounded-md hover:bg-gray-800"
                    type="submit"
                    onClick={() => setIsLitigationDecisionOpen(true)}
                  >
                    {t("addAppealLitigationDecision")}
                  </button>
                )}

              {/* Inspection Litigation Termination */}
              {/* {canTerminateInspectionLitigation &&
                courtAppealLitigationData &&
                !courtAppealLitigationData[0]?.termination_reason &&
                courtAppealLitigationData[0]?.is_final_verdict_given && (
                  <button
                    className="bg-red-900 text-white px-8 py-2 rounded-md hover:bg-gray-800"
                    type="submit"
                    onClick={() => setIsTerminateOpen(true)}
                  >
                    {t("terminate")}
                  </button>
                )} */}
            </div>
          )}
        </div>
      </div>

      <div className="relative">
        <div
          className={`grid grid-cols-1 lg:grid-cols-3 gap-4 ${
            isInitialLoading ? "pointer-events-none opacity-40" : ""
          }`}
        >
          {/* Detail Info */}
          {activeTab === tabs[0] && (
            <div className="lg:col-span-2 space-y-4">
              {investigationData &&
                complaintData &&
                !Array.isArray(complaintData) &&
                (canViewChargeDoc ||
                  investigationData?.status ===
                    INVESTIGATION_STATUS.FORWARDED_TO_COUNCIL) && (
                  <ChargeDocumentCardAdvocate
                    investigationData={investigationData}
                    complaintData={complaintData}
                    onInvestigationRefresh={loadInvestigations}
                  />
                )}

              {canViewCompliantDetail &&
                complaintData &&
                !Array.isArray(complaintData) &&
                complaintData.status !== COMPLIANT_STATUS?.PENDING && (
                  <DecisionCard
                    complaintData={complaintData}
                    investigationData={investigationData}
                    allInvestigationData={allInvestigationData}
                    onInvestigationRefresh={loadInvestigations}
                  />
                )}

              {canViewCompliantDetail && (
                <ComplaintDetailInfoCard
                  complaintData={complaintData}
                  onComplaintsRefresh={loadComplaints}
                />
              )}
            </div>
          )}

          {/*Council Appeal */}
          {activeTab === tabs[1] && (
            <div className="lg:col-span-2 space-y-4">
              {appealSummonData &&
                complaintData &&
                !Array.isArray(complaintData) && (
                  <AppealSummonCard
                    summonData={appealSummonData}
                    compliantData={complaintData}
                    onSummonRefresh={loadSummon}
                  />
                )}

              {complaintData &&
                !Array.isArray(complaintData) &&
                councilAppealData &&
                councilAppealData?.length > 0 && (
                  <AppealCard
                    complaintData={complaintData}
                    appealData={councilAppealData}
                    onAppealRefresh={loadAppeal}
                    showAddRegistration={true}
                  />
                )}

              {complaintData &&
                !Array.isArray(complaintData) &&
                councilLitigationData &&
                councilLitigationData?.length > 0 && (
                  <InitialDecisionCard
                    complaintData={complaintData}
                    councilLitigationData={councilLitigationData[0]}
                    onAppealRefresh={loadAppeal}
                  />
                )}
            </div>
          )}

          {/* Council Litigation */}
          {activeTab === tabs[2] && (
            <div className="lg:col-span-2 space-y-4">
              {appealCouncilLitigationData &&
                appealCouncilLitigationData?.length > 0 && (
                  <AppealCouncilLitigationCard
                    councilLitigationData={appealCouncilLitigationData}
                    onCouncilLitigationRefresh={loadAppealCouncilLitigation}
                  />
                )}

              {appealLitigationData && appealLitigationData?.length > 0 && (
                <AppealLitigationCard
                  litigationData={appealLitigationData}
                  councilLitigationData={appealCouncilLitigationData || []}
                  onLitigationRefresh={loadAppealLitigation}
                />
              )}
            </div>
          )}

          {/* Appeal To General Council */}
          {activeTab === tabs[3] && (
            <div className="lg:col-span-2 space-y-4">
              {courtAppealSummonDataForGeneralCouncil &&
                complaintData &&
                !Array.isArray(complaintData) && (
                  <AppealSummonCard
                    summonData={courtAppealSummonDataForGeneralCouncil}
                    compliantData={complaintData}
                    onSummonRefresh={loadCourtAppealSummonForGeneralCouncil}
                  />
                )}

              {complaintData &&
                !Array.isArray(complaintData) &&
                courtAppealDataForGeneralCouncil &&
                courtAppealDataForGeneralCouncil?.length > 0 && (
                  <AppealCard
                    complaintData={complaintData}
                    appealData={courtAppealDataForGeneralCouncil}
                    showHearingHistory={true}
                    onAppealRefresh={loadCourtAppealSummonForGeneralCouncil}
                    showAddRegistration={true}
                    hideAppealType={activeTab === tabs[3]}
                  />
                )}
            </div>
          )}

          {/* Court Litigation */}
          {activeTab === tabs[4] && (
            <div className="lg:col-span-2 space-y-4">
              {courtAppealCouncilLitigationData &&
                courtAppealCouncilLitigationData?.length > 0 && (
                  <AppealCouncilLitigationCard
                    councilLitigationData={courtAppealCouncilLitigationData}
                    onCouncilLitigationRefresh={
                      loadCourtAppealCouncilLitigation
                    }
                  />
                )}

              {courtAppealLitigationDataForGeneralCouncil &&
                courtAppealLitigationDataForGeneralCouncil?.length > 0 && (
                  <AppealLitigationCard
                    litigationData={courtAppealLitigationDataForGeneralCouncil}
                    councilLitigationData={
                      courtAppealCouncilLitigationData || []
                    }
                    onLitigationRefresh={
                      loadCourtAppealLitigationForGeneralCouncil
                    }
                  />
                )}
            </div>
          )}

          {/* Appeal To Court */}
          {activeTab === tabs[5] && (
            <div className="lg:col-span-2 space-y-4">
              {courtAppealSummonDataForCourt &&
                complaintData &&
                !Array.isArray(complaintData) && (
                  <AppealSummonCard
                    summonData={courtAppealSummonDataForCourt}
                    compliantData={complaintData}
                    onSummonRefresh={loadCourtAppealSummon}
                  />
                )}

              {complaintData &&
                !Array.isArray(complaintData) &&
                courtAppealDataForCourt &&
                courtAppealDataForCourt?.length > 0 && (
                  <AppealCard
                    complaintData={complaintData}
                    appealData={courtAppealDataForCourt}
                    showHearingHistory={true}
                    onAppealRefresh={loadAppeal}
                    showAddRegistration={false}
                  />
                )}
            </div>
          )}

          {/* Court Litigation */}
          {activeTab === tabs[6] && (
            <div className="lg:col-span-2 space-y-4">
              {/* {courtAppealCouncilLitigationData &&
              courtAppealCouncilLitigationData?.length > 0 && (
                <AppealCouncilLitigationCard
                  councilLitigationData={courtAppealCouncilLitigationData}
                  onCouncilLitigationRefresh={loadCourtAppealCouncilLitigation}
                />
              )} */}

              {courtAppealLitigationDataForCourt &&
                courtAppealLitigationDataForCourt?.length > 0 && (
                  <AppealLitigationCard
                    litigationData={courtAppealLitigationDataForCourt}
                    councilLitigationData={
                      courtAppealCouncilLitigationData || []
                    }
                    onLitigationRefresh={loadCourtAppealLitigationForCourt}
                    showForHead={isRegionalCouncilOfficeHead}
                  />
                )}
            </div>
          )}

          {/* Sidebar */}
          <div className="space-y-4">
            {canViewSummonConfirmation &&
              ((activeTab === tabs[1] && appealSummonData && (
                <SummonConfirmationStatus summonData={appealSummonData} />
              )) ||
                (activeTab === tabs[5] && courtAppealSummonDataForCourt && (
                  <SummonConfirmationStatus
                    summonData={courtAppealSummonDataForCourt}
                  />
                )))}

            {canViewAssignedHistory && assignmentHistoryData && (
              <AssignedProsecutorHistory
                data={assignmentHistoryData?.map((obj: any) => ({
                  ...obj,
                  assignedTo: obj?.assigned_prosecutor,
                  assignedDate: obj?.assigned_date,
                }))}
              />
            )}

            {canViewCompliantDetail && (
              <>
                <ListEvidenceCard
                  complaintData={complaintData}
                  onComplaintsRefresh={loadComplaints}
                />
                <ListReporterCard
                  complaintData={complaintData}
                  onComplaintsRefresh={loadComplaints}
                />
                <ListVictimCard
                  complaintData={complaintData}
                  onComplaintsRefresh={loadComplaints}
                />
                <ListWitnessCard
                  complaintData={complaintData}
                  onComplaintsRefresh={loadComplaints}
                />
              </>
            )}
          </div>
        </div>

        {isInitialLoading && (
          <div className="absolute inset-0 z-20 flex justify-center items-start pt-8 rounded-xl bg-gradient-to-br from-white/90 to-red-50/80 backdrop-blur-sm">
            <div className="flex flex-col items-center gap-3 rounded-lg border border-red-100 bg-white/80 px-6 py-5 shadow-sm">
              <div className="h-10 w-10 border-4 border-red-600/80 border-t-transparent rounded-full animate-spin" />
              <p className="text-sm font-semibold text-gray-700">Loading...</p>
            </div>
          </div>
        )}
      </div>

      {/* /////////////////// MODAL FORMS ///////////////////  */}

      {complaintData && !Array.isArray(complaintData) && (
        <>
          {((activeTab === tabs[5] && courtAppealData && courtAppealData[0]) ||
            (activeTab !== tabs[5] &&
              councilAppealData &&
              councilAppealData[0])) && (
            <AddAppealSummonModal
              isOpen={isAppealSummonOpen}
              setIsOpen={setIsAppealSummonOpen}
              appealData={
                activeTab === tabs[3]
                  ? courtAppealDataForGeneralCouncil![0]
                  : activeTab === tabs[5]
                    ? courtAppealDataForCourt![0]
                    : councilAppealData![0]
              }
              complaintData={complaintData}
              onAppealSummonRefresh={loadAppeal}
            />
          )}
        </>
      )}

      {complaintData &&
        !Array.isArray(complaintData) &&
        ((activeTab === tabs[2] && appealSummonData) ||
          (activeTab === tabs[4] && courtAppealDataForGeneralCouncil) ||
          (activeTab === tabs[6] && courtAppealDataForCourt)) &&
        !Array.isArray(appealSummonData) && (
          <AddAppealDailyHearingModal
            isOpen={isDailyHearingOpen}
            setIsOpen={setIsDailyHearingOpen}
            summonData={
              activeTab === tabs[6]
                ? courtAppealSummonDataForCourt!
                : activeTab === tabs[4]
                  ? courtAppealSummonDataForGeneralCouncil!
                  : appealSummonData!
            }
            appealData={
              activeTab === tabs[6]
                ? courtAppealDataForCourt![0]
                : activeTab === tabs[4]
                  ? courtAppealDataForGeneralCouncil![0]
                  : councilAppealData![0]
            }
            complaintData={complaintData}
            onLitigationRefresh={
              activeTab === tabs[6] || activeTab === tabs[4]
                ? activeTab === tabs[6]
                  ? loadCourtAppealLitigationForCourt
                  : loadCourtAppealLitigationForGeneralCouncil
                : loadAppealLitigation
            }
            onCouncilLitigationRefresh={
              activeTab === tabs[6] || activeTab === tabs[4]
                ? loadCourtAppealCouncilLitigation
                : loadAppealCouncilLitigation
            }
          />
        )}

      {((activeTab === tabs[2] &&
        appealLitigationData &&
        appealLitigationData[0]) ||
        (activeTab === tabs[4] &&
          courtAppealLitigationDataForGeneralCouncil &&
          courtAppealCouncilLitigationData &&
          courtAppealLitigationDataForGeneralCouncil[0]) ||
        (activeTab === tabs[6] &&
          courtAppealLitigationDataForCourt &&
          courtAppealCouncilLitigationData &&
          courtAppealLitigationDataForCourt[0])) &&
        complaintData &&
        !Array.isArray(complaintData) && (
          <AddAppealLitigationDecisionModal
            isOpen={isLitigationDecisionOpen}
            setIsOpen={setIsLitigationDecisionOpen}
            complaintData={complaintData}
            litigationData={
              activeTab === tabs[6] || activeTab === tabs[4]
                ? isRegionalCouncilOfficeHead
                  ? courtAppealCouncilLitigationData![0]
                  : activeTab === tabs[6]
                    ? courtAppealLitigationDataForCourt![0]
                    : courtAppealLitigationDataForGeneralCouncil![0]
                : appealLitigationData![0]
            }
            onRefresh={
              activeTab === tabs[6] || activeTab === tabs[4]
                ? activeTab === tabs[6]
                  ? loadCourtAppealLitigationForCourt
                  : loadCourtAppealLitigationForGeneralCouncil
                : loadAppealLitigation
            }
          />
        )}

      {appealCouncilLitigationData &&
        complaintData &&
        !Array.isArray(complaintData) && (
          <AddAppealCouncilLitigationDecisionModal
            isOpen={isCouncilLitigationDecisionOpen}
            setIsOpen={setIsCouncilLitigationDecisionOpen}
            complaintData={complaintData}
            councilLitigationData={appealCouncilLitigationData[0]}
            onRefresh={loadAppealCouncilLitigation}
          />
        )}

      {complaintData && !Array.isArray(complaintData) && (
        <AddAppealToCourtModal
          isOpen={isAppealCourtOpen}
          setIsOpen={setIsAppealCourtOpen}
          complaintData={complaintData}
          onCompliantRefresh={loadComplaints}
          isAppealToCourt={true}
        />
      )}

      {complaintData && !Array.isArray(complaintData) && (
        <AddAppealToCourtModal
          isOpen={isAppealGeneralCouncilOpen}
          setIsOpen={setIsAppealGeneralCouncilOpen}
          complaintData={complaintData}
          onCompliantRefresh={loadComplaints}
          isAppealToGeneralCouncil={true}
        />
      )}

      <ConfirmationModal
        isOpen={isSendToRegistrarModal}
        onCancel={() => setIsSendToRegistrarModal(false)}
        onConfirm={
          activeTab === tabs[1]
            ? handleSendToRegistrarConfirm
            : handleCourtSendToRegistrarConfirm
        }
        isLoading={isSubmitLoading}
      />

      <ConfirmationModal
        isOpen={isSendToCouncilModal}
        onCancel={() => setIsSendToCouncilModal(false)}
        onConfirm={
          activeTab === tabs[1]
            ? handleSendToCouncilConfirm
            : activeTab === tabs[3]
              ? handleGeneratlCouncilSendToCouncilConfirm
              : handleCourtSendToCouncilConfirm
        }
        isLoading={isSubmitLoading}
      />

      {complaintData &&
        councilAppealData &&
        Array.isArray(councilAppealData) && (
          <RejectAppealModal
            isOpen={isAppealRejectOpen}
            setIsOpen={setIsAppealRejectOpen}
            complaintData={complaintData as Complaints}
            appealData={councilAppealData[0]}
            onComplaintRefresh={loadLitigation}
          />
        )}
      {complaintData &&
        !Array.isArray(complaintData) &&
        councilLitigationData &&
        Array.isArray(councilLitigationData) && (
          <AddCouncilOfficeVerdictInitialDay
            isOpen={isInitialHearingDecisionOpen}
            setIsOpen={setIsInitialHearingDecisionOpen}
            complaintData={complaintData}
            councilLitigationData={councilLitigationData[0]}
            onRefresh={loadLitigation}
          />
        )}

      <ConfirmationModal
        isOpen={isRejectAppealOpen}
        onCancel={() => setIsRejectAppealOpen(false)}
        onConfirm={
          activeTab === tabs[1] ? handleRejectAppeal : handleCourtRejectAppeal
        }
        isLoading={isSubmitLoading}
      />
    </div>
  );
}
